import React from 'react';
import './EditForm.css'; // Reusing the same styling

const NewEntryForm = ({ columns, formData, onChange, onCancel, onSubmit }) => {
  if (!columns || columns.length === 0) return null;

  return (
    <div className="edit-form-wrapper">
      <div className="edit-form-card shadow rounded bg-white">
        <h4 className="text-center text-success fw-bold mb-4 border-bottom pb-2">
          ➕ Add New Record
        </h4>

        <form onSubmit={onSubmit} className="row gx-4 gy-3">
          {columns.map((col) => (
            <div className="col-md-6" key={col}>
              <label className="form-label text-capitalize">{col.replace(/_/g, ' ')}</label>
              <input
                type="text"
                name={col}
                value={formData[col] || ''}
                onChange={onChange}
                className="form-control"
                disabled={col === 'id'}
              />
            </div>
          ))}

          <div className="form-buttons">
            <button type="submit" className="btn btn-success">➕ Add</button>
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewEntryForm;
